/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, {useState, useCallback} from "react";

// Chakra imports
import { Box } from "@chakra-ui/react";
import Banner from "views/main/sumaadmin/components/Banner";
import SumasTable from "views/main/sumaadmin/components/SumasTable";
import Addsuma from "views/main/sumaadmin/components/Addsuma";

export default function SukelAdmin() {
  // variable sukellist
  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshing]);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Banner/><br/><Addsuma onRefresh={onRefresh}/><br/><SumasTable refreshing={refreshing}/>
    </Box>
  );
}
